import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LogoutConfirmationComponent } from '../logout-confirmation/logout-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss']
})
export class HomeDashboardComponent implements OnInit {
  filteredMenuItems: any[] = [];
  public access: any;
  public menuCont: any;
  public copyMenuCont: any;
  public searchText: string = '';

  constructor(
    public sidePanelService: SidePanelService,
    public notifier: NotifierService,
    public router: Router,
    public http: HttpClient,
    public dialog: MatDialog
  ) {
    this.access = JSON.parse(localStorage.getItem('access'));
    this.sidePanelService.homeDashboardAfterLogin();
  }

  ngOnInit(): void {
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    }  
    this.http.post<any>(environment.apiUrl + `/api/user/checksession`,{},httpPostOptions)
    .subscribe((data) =>{
      if(data && data.status){
        setTimeout(() =>{
          this.menuCont = this.sidePanelService.sideDrawer.mainMenu.filter((menu) => menu.name !== 'More');
          this.modifyMenuContainer();
          this.copyMenuCont = JSON.parse(JSON.stringify(this.menuCont));
        },100);
      }else{
        localStorage.removeItem('access');
        this.router.navigate(['/login']);
      }
    });
    
  }

 
  onSearchChange(event: any): void {
    this.searchText = event.target.value.toLowerCase();
    if (this.searchText) {
      this.menuCont = this.copyMenuCont.filter(menu => menu.name.toLowerCase().startsWith(this.searchText) || menu.desc.toLowerCase().includes(this.searchText));
    }else{
      this.menuCont = this.copyMenuCont; // Reset to original list if search is empty
    }
  }

  modifyMenuContainer():void{
    this.menuCont.forEach((menu) => {
      switch (menu.name) {
        case 'Repository':
          menu.desc = 'Inventory for project reports, Cross tabing, Create Toplines, Significance testing, Survey Translations, VOC, Video Analysis and lot more.';
          menu.icon = 'assets/Landing_Page_Icon/Repository.png'
          break;
        case 'Dashboard':
          menu.desc = 'Track your studies performance in real time including quotas, funnels, raw data etc.';
          menu.icon = 'assets/Landing_Page_Icon/Home(Dashboard).png';
          break;
        case 'Projects':
          menu.desc = 'Find all studies for a single project conveniently grouped together in one location.';
          menu.icon = 'assets/Landing_Page_Icon/Projects.png';
          break;
        case 'Manage Recuiters':
          menu.desc = 'Manage your recruiters, assign them to projects, and track their performance.';
          menu.icon = 'assets/Landing_Page_Icon/user_management.png';
          break;
        case 'Eaglelive':
          menu.desc = "Manage and Create your live projects, including video interviews, live streaming, and more.";
          menu.icon = 'assets/Landing_Page_Icon/eaglelive_icon.png';
          break;
        case 'Ipsos Consumer Voice (ICV)':
          menu.desc = 'DIY tool for your qual needs. Check feasibility, Join Interviews, AI analysed videos, transcripts, Interview summary etc.';
          menu.icon = 'assets/Landing_Page_Icon/icv_1.png';
          break;
        case 'User Management':
          menu.desc = 'Effortlessly create, manage, and organize all Eagle Insight users and organizations.';
          menu.icon = 'assets/Landing_Page_Icon/User-Management.png';
          break;
        case 'Survey Builder':
          menu.desc = '	Build surveys easily from your questionnaire with a simple, do-it-yourself scripting tool.';
          menu.icon = 'assets/Landing_Page_Icon/Survey-Builder.png';
          break;
        case 'MRSI':
          menu.desc = 'Simplify your market research with MRSI, a comprehensive platform for managing and analyzing your research projects.';
          menu.icon = 'assets/Landing_Page_Icon/mrsi_icon.png';
          break;
        case 'COS':
          menu.desc = '	COS, an innovative automated contract tool for online services under ₹ 20 lakhs, entirely digital, making contract management faster & efficient.';
          menu.icon = 'assets/Landing_Page_Icon/cos_icon.png';
          break;
        case 'Express Insights':
          menu.desc = 'Need insights fast? Our Express Insights tool delivers! Get a templated, 5-slide PowerPoint deck with detailed insights in just 3-6 hours.';
          menu.icon = 'assets/Landing_Page_Icon/express.png';
          break;
        case 'Client Master':
          menu.desc = 'Instantly access all the information and details you need for any of your clients in one central location.';
          menu.icon = 'assets/Landing_Page_Icon/client_master.png';
          break;
        case 'Trinity':
          menu.desc = 'Check feasibility of your projects and get the costing in realtime';
          menu.icon = 'assets/Landing_Page_Icon/trinity_icon.png';
          break;
        case 'iField QA Dashboard':
          menu.desc ='Track rejection rate for iField data on different basis like YoY, QoQ, Field etc.';
          menu.icon = 'assets/Landing_Page_Icon/ifield_qa_dash.png';
          break;
        case 'Dashboard Suite':
          menu.desc ='Central hub for growth & operational analytics. Monitor user acquisition, panel strength, marketing performance & project health.';
          menu.icon = 'assets/Landing_Page_Icon/superset-dash.png';
          break;  

      }
    });
    // console.log(this.menuCont);

  }

  navigateTo(route: string): void {
    switch (route) {
      case '/repo':
        this.sidePanelService.initSideDrawer('home');
        break;
      case '/home/dashboard':
        this.sidePanelService.initSideDrawer('home');
        break;

      case '/home/projects':
        this.sidePanelService.initSideDrawer('home');
        break;

      case '/home/recruiters':
        this.sidePanelService.initSideDrawer('home');
        break;

      case '/eagle-live/dashboard':
        this.sidePanelService.initSideDrawer('eaglelive');
        break;

      case '/consumer-immersions/request-list':
        this.sidePanelService.initSideDrawer('ci');
        break;

      case '/user-manager/users':
        this.sidePanelService.initSideDrawer('user');
        break;

      case '/surveys/listing':
        this.sidePanelService.initSideDrawer('survey');
        break;

      case '/mrsi':
        this.sidePanelService.initSideDrawer('mrsi');
        break;

      case '/contract':
        this.sidePanelService.initSideDrawer('contract');
        break;

      case '/express':
        this.sidePanelService.initSideDrawer('express');
        break;

      case '/client-master':
        this.sidePanelService.initSideDrawer('client-master');
        break;

      case '/qa-report/qa-dashboard':
        this.sidePanelService.initSideDrawer('qa-report');
        break;

      case '/trinity':
        this.sidePanelService.initSideDrawer('trinity');
        break;
      
      case '/dash-suite':
        this.sidePanelService.initSideDrawer('superset_dashboard');
        break;

      default:
        this.notifier.notify('error', 'You are not authorized');
        break;
    }

    setTimeout(() =>{
      this.router.navigate([route]);
    },100)

  }

  logoutPopUpConfirmation():void{
    this.dialog.open(LogoutConfirmationComponent, {});
  }

 

}
